/* eslint-disable no-undef */
export default {
	name: "dashboard",
	data() {
		return {
			recentCollectionOrders: [],
			recentDeliveryOrders: [],
			loading: false
		};
	},
	methods: {
		getCollectionOrders(){
			this.loading = true;
			this.recentCollectionOrders = [
				{
					orderId: 1,
					orderDate: "08/05/2023",
					vehicle: "ND122121",
					fleetNumber: "ABC545477",
					manifestNumber: "XYZ01121212",
					total: 500.00,
					orderStatus: "Completed"
				},
				{
					orderId: 2,
					orderDate: "07/05/2023",
					vehicle: "ND122121",
					fleetNumber: "ABC111111111",
					manifestNumber: "XYZ01121212",
					total: 900.00,
					orderStatus: "Completed"
				},
				{
					orderId: 3,
					orderDate: "08/05/2023",
					vehicle: "ND122121",
					fleetNumber: "ABC545477",
					manifestNumber: "XYZ01121212",
					total: 1000.00,
					orderStatus: "Completed"
				}
			];
			this.loading = false;
		}
	},
	mounted: function () {
		storeState.setPageTitleAction("Dashboard");
		breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Dashboard");
		this.getCollectionOrders();
	}
};